import React, { useContext } from "react";
import { Row, Col, Spinner, Input, Button } from "reactstrap";
import { DF_OT0024Context } from "../context";

const inputClassName = "w-100 rounded font-size-14 border-color-cinza2 text-dark";

const DIAS = [
  { key: "segunda", label: "Seg" },
  { key: "terca",   label: "Ter" },
  { key: "quarta",  label: "Qua" },
  { key: "quinta",  label: "Qui" },
  { key: "sexta",   label: "Sex" },
  { key: "sabado",  label: "Sab" },
  { key: "domingo", label: "Dom" },
];

export default function GridBody() {
  const context = useContext(DF_OT0024Context);
  const { formData, handleInputChange, isLoading, handleSave } = context || {};

  return (
    <>
      <Row>
        <div className="position-relative w-100" style={{ minHeight: "80px" }}>
          {isLoading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 z-index-10">
              <Spinner className="text-primary" size="sm" />
            </div>
          )}

          <div className="w-100 table-responsive font-size-13">
            <table className="table table-borderless align-middle mb-0 w-100">
              <thead>
                <tr>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Limites Dia R$
                  </th>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Limites Semana R$
                  </th>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Limites Mês R$
                  </th>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Tempo Médio Descarga (Min)
                  </th>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Exclusividade
                  </th>
                  <th className="font-size-12 font-w-600 px-2 py-1 text-start text-dark bg-color-cinza2">
                    Status
                  </th>
                  {DIAS.map(({ key, label }) => (
                    <th
                      key={`header-${key}`}
                      className="font-size-12 font-w-600 px-2 py-1 text-center text-dark bg-color-cinza2"
                      style={{ width: "42px" }}
                    >
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-1">
                    <Input
                      type="text"
                      className={inputClassName}
                      value={formData?.limiteDia || ""}
                      onChange={(e) => handleInputChange?.("limiteDia", e.target.value)}
                    />
                  </td>
                  <td className="p-1">
                    <Input
                      type="text"
                      className={inputClassName}
                      value={formData?.limiteSemana || ""}
                      onChange={(e) => handleInputChange?.("limiteSemana", e.target.value)}
                    />
                  </td>
                  <td className="p-1">
                    <Input
                      type="text"
                      className={inputClassName}
                      value={formData?.limiteMes || ""}
                      onChange={(e) => handleInputChange?.("limiteMes", e.target.value)}
                    />
                  </td>
                  <td className="p-1">
                    <Input
                      type="number"
                      className={inputClassName}
                      value={formData?.tempoMedioDescarga || ""}
                      onChange={(e) => handleInputChange?.("tempoMedioDescarga", e.target.value)}
                    />
                  </td>
                  <td className="p-1">
                    <Input
                      type="select"
                      className={`${inputClassName} form-select`}
                      value={formData?.exclusividade || "Não"}
                      onChange={(e) => handleInputChange?.("exclusividade", e.target.value)}
                    >
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </Input>
                  </td>
                  <td className="p-1">
                    <Input
                      type="select"
                      className={`${inputClassName} form-select`}
                      value={formData?.status || "Ativo"}
                      onChange={(e) => handleInputChange?.("status", e.target.value)}
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Desativado">Desativado</option>
                    </Input>
                  </td>
                  {DIAS.map(({ key }) => (
                    <td key={`cell-${key}`} className="text-center p-1">
                      <input
                        type="checkbox"
                        className="form-check-input cursor-pointer m-0 align-middle style-checkbox-16"
                        checked={!!formData?.[key]}
                        onChange={(e) => handleInputChange?.(key, e.target.checked)}
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Row>

      <Row className="mt-3">
        <Col className="d-flex justify-content-end">
          <Button
            className="bg-primary-dark border-0 text-white font-w-600 rounded px-4 py-2"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? <Spinner size="sm" /> : "Salvar Seleção"}
          </Button>
        </Col>
      </Row>
    </>
  );
}